module.exports = __webpack_public_path__ + "static/img/roland_profile_ph.93d90f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/roland_profile_ph.png
// module id = QMVl
// module chunks = 0